<template>
  <div class="product-inspiration">
    <ClientOnly>
      <Teleport to="#teleports">
        <LazyModal
          v-if="show"
          small
          hide-header
          no-padding
          @close="hideModal">
          <ImageAlbum
            :items="items.map(item =>`${config.public.cdnURL}pictures/related_media/hd/${item.id}.webp`)"
            :thumbs="items.map(item =>`${config.public.cdnURL}pictures/related_media/medium/${item.id}.webp`)"
            :active="items.findIndex(item => item.id === show.id)"
            @select="index => show = items[index]" />
        </LazyModal>
      </Teleport>
    </ClientOnly>
    <LazyCarousel
      title="Get inspired"
      show-icon
      :items="items">
      <template #item="{ item }">
        <img
          :key="item.id"
          class="product-inspiration__item"
          :src="`${config.public.cdnURL}pictures/related_media/medium/${item.id}.webp`"
          @click="showModal(item)">
      </template>
    </LazyCarousel>
  </div>
</template>
<script setup>
const config = useRuntimeConfig()
defineProps({
  items: {
    type: [Array],
    default: null
  }
})

const show = ref(null)

const showModal = item => {
  show.value = item
}

const hideModal = () => {
  show.value = null
}

</script>
<style lang="scss" scoped>
.product-inspiration {
  @media (max-width: #{$breakpoint-small-desktop}) {
    padding: 0 calc(var(--spacing ) * 2);
  }

  &__item {
    cursor: pointer;

    &:hover,
    &:focus {
      opacity: 0.8;
    }
  }

  &__big-image {
    display: block;
  }
}
</style>
